module.exports = __webpack_public_path__ + "img/package-variant-plus.0718d871.svg";